/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */
import '@material/list/mdc-list.scss';

/**
 * Create the component.
 */
export default class ListItem extends Component {
  render({
           'class': className,
           children,
           role,
           link,
           ...props
         }, state, context) {
    const classes = classnames('mdc-list-item', className);
    return link ? <a class={classes} {...props}>{children}</a> : <li class={classes} {...props} role={role}>{children}</li>;
  }
}



// WEBPACK FOOTER //
// ../q-mdc/elements/material-list-item/index.js